var map = {
	"./cheer_up_0.png": 82256,
	"./cheer_up_1.png": 61485,
	"./cheer_up_2.png": 24984,
	"./cheer_up_3.png": 83022,
	"./cheer_up_4.png": 53015,
	"./cheer_up_5.png": 31993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56071;